import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheStorageService {
  cache: any = {}
  constructor() {}

  /**
   * Manually invalidate all cached GET responses for a specific FHIR resource type
   * @param resourceType e.g., 'Observation', 'Patient'
   */
  clearCacheForResource(resourceType: string): void {
    Object.keys(this.cache).forEach(key => {
      // Matches basic FHIR search/read endpoints for this resource
      if (key.includes(`/${resourceType}`) || key.includes(`?_type=${resourceType}`)) {
        delete this.cache[key];
      }
    });
  }
}
